import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-more-info-hc-cost',
  templateUrl: './more-info-hc-cost.component.html',
  styleUrls: ['./more-info-hc-cost.component.scss']
})
export class MoreInfoHcCostComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<MoreInfoHcCostComponent>) { }

  ngOnInit(): void {
  }
  onClose() {
    this.dialogRef.close();
  }

}
